import {getStationCode} from "../../network/NetworkUtil";
import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {logOperationalMetric} from "../../util/Util";

const metricProcessName = "SCC_RECEIVE";
export function getPackages(filter, dispatcher, lineHaulId, containerId, packageState) {
    let filterMap = {
        "Cycle": filter.Cycle,
        "EAD": filter.EAD,
        "OtherAttributes": filter.OtherAttributes,
        "Cluster": filter.Cluster,
        "PackageSize": filter.PackageSize
    };
    const request = {
        nodeId: getStationCode(),
        lineHaulId: lineHaulId,
        containerId: containerId,
        packageState: packageState,
        filters: filterMap
    };
    getPackageList(dispatcher, request);
}

function getPackageListAPIGatewayRequest(request) {
    return {
        resourcePath: "/ivs/getPackageList",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

async function getPackageList(dispatcher, request) {
    const args = getPackageListAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getPackageList", true);
            let output = result.data.packageList;
            const packageMetrics = output.map(packageMetric => {
                packageMetric['minInState'] = parseInt(packageMetric['minInState'], 10);
                return packageMetric;
            })
            dispatcher({type: "RECEIVE_DATA", data: {
                packageList: packageMetrics
            }});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getPackageList", false);
        }
    });
}


// WEBPACK FOOTER //
// ./src/components/package/network/PackageListNetworkAPI.js